import { useTrDayOfWeek as e } from "./useTrDayOfWeek.mjs";
import { useCallback as t } from "react";
import { useTranslation as n } from "react-i18next";
import { CheckoutReasonCode as r } from "@maat/api-booking/types";
import { formatDateShort as i } from "@maat/datetime";
//#region src/enums/useTrCheckoutReason.ts
var a = () => {
	let { t: a } = n("booking"), o = e();
	return t((e) => {
		if (!e) return;
		let { nights: t, minStay: n, maxStay: s, day: c, date: l } = e.params ?? {};
		switch (e.code) {
			case r.MinStay: return a("availabilityCalendar.minStayError", {
				count: t,
				minStay: n
			});
			case r.MaxStay: return t === void 0 ? a("availabilityCalendar.maxStay", { count: s }) : a("availabilityCalendar.maxStayError", {
				count: t,
				maxStay: s
			});
			case r.DisallowCheckoutDay: return c ? a("availabilityCalendar.noCheckoutOn", { day: o(c) }) : a("availabilityCalendar.checkoutUnavailable");
			case r.Rejected: return a("availabilityCalendar.stayRejected");
			case r.Closed: return l ? a("availabilityCalendar.nightClosedOn", { date: i(l) }) : a("availabilityCalendar.nightClosed");
			case r.ClosedToArrival: return l ? a("availabilityCalendar.closedToArrivalOn", { date: i(l) }) : a("availabilityCalendar.closedToArrival");
			case r.ClosedToDeparture: return l ? a("availabilityCalendar.closedToDepartureOn", { date: i(l) }) : a("availabilityCalendar.closedToDeparture");
			case r.IdentityNotVerified: return a("checkout.identity.notVerified");
			case r.IdentityVerificationPending: return a("checkout.identity.pending");
			case r.IdentityVerificationRejected: return a("checkout.identity.rejected");
			case r.ExternalPricingRecalibrating: return a("checkout.externalPricing.recalibrating");
			case r.ExternalPricingUnavailable: return a("checkout.externalPricing.unavailable");
			default: return a("availabilityCalendar.checkoutUnavailable");
		}
	}, [a, o]);
};
//#endregion
export { a as useTrCheckoutReason };
